import { IDaySchedule, IScheduleSettings, ISpecialDay, ITime, ITimingRule, IWeeklySchedule } from '@core/types'
import { ApiProperty } from '@nestjs/swagger'
import { Type } from 'class-transformer'
import { ArrayNotEmpty, IsBoolean, IsDate, IsNotEmptyObject, IsNumber, Max, Min, ValidateNested } from 'class-validator'

export class Time implements ITime {
	@ApiProperty({
		type: Number,
		minimum: 0,
		maximum: 23,
	})
	@IsNumber()
	@Min(0)
	@Max(23)
	hours: number

	@ApiProperty({
		type: Number,
		minimum: 0,
		maximum: 59,
	})
	@IsNumber()
	@Min(0)
	@Max(59)
	minutes: number
}

export class TimingRule implements ITimingRule {
	@ApiProperty({ type: () => Time })
	@IsNotEmptyObject()
	openingTime: Time

	@ApiProperty({ type: () => Time })
	@IsNotEmptyObject()
	closingTime: Time
}

export class DaySchedule implements IDaySchedule {
	@ApiProperty({ type: Boolean })
	@IsBoolean()
	closed: boolean

	@ApiProperty({ type: TimingRule, isArray: true })
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => TimingRule)
	rules: Array<TimingRule>
}

export class WeeklySchedule implements IWeeklySchedule {
	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Monday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Tuesday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Wednesday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Thursday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Friday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Saturday: DaySchedule

	@ApiProperty({ type: DaySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	Sunday: DaySchedule
}

export class SpecialDay implements ISpecialDay {
	@ApiProperty({ type: Date })
	@IsDate()
	date: Date

	@ApiProperty({ type: Boolean })
	@IsBoolean()
	recurring: boolean

	@ApiProperty({ type: Boolean })
	@IsBoolean()
	closed: boolean

	@ApiProperty({ type: TimingRule, isArray: true })
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => TimingRule)
	rules: Array<TimingRule>
}

export class ScheduleSettings implements IScheduleSettings {
	@ApiProperty({ type: WeeklySchedule })
	@IsNotEmptyObject()
	@ValidateNested()
	weeklySchedule: WeeklySchedule

	@ApiProperty({ type: SpecialDay, isArray: true })
	@IsNotEmptyObject()
	@ValidateNested()
	@Type(() => SpecialDay)
	specialDays: SpecialDay[]
}
